import { useEffect } from 'react';

import { loadUserKeepALiveData, releaseOpenTradesFeed, retainOpenTradesFeed } from '~/state/reducers/userDataSlice';
import { useAppDispatch } from './useAppDispatch';

// The slice reference counts, so a second mounted consumer is safe.
export const useOpenTradesFeed = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(retainOpenTradesFeed());
        dispatch(loadUserKeepALiveData());
        return () => {
            dispatch(releaseOpenTradesFeed());
        };
    }, [dispatch]);
};
